var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarStandard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#F9F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6666 31.625V29.7083C30.6666 28.6917 30.2627 27.7166 29.5438 26.9978C28.8249 26.2789 27.8499 25.875 26.8333 25.875H19.1666C18.1499 25.875 17.1749 26.2789 16.456 26.9978C15.7371 27.7166 15.3333 28.6917 15.3333 29.7083V31.625M26.8333 18.2083C26.8333 20.3254 25.117 22.0417 22.9999 22.0417C20.8828 22.0417 19.1666 20.3254 19.1666 18.2083C19.1666 16.0912 20.8828 14.375 22.9999 14.375C25.117 14.375 26.8333 16.0912 26.8333 18.2083Z",
    stroke: "#FFC107",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 22.5,
    stroke: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarStandard);
export default __webpack_public_path__ + "static/media/Avatar_standard.84d8a21460417301321d0b31e87569c9.svg";
export { ForwardRef as ReactComponent };